import { render, staticRenderFns } from "./EditDrugs.vue?vue&type=template&id=50507a98&scoped=true"
import script from "./EditDrugs.vue?vue&type=script&lang=js"
export * from "./EditDrugs.vue?vue&type=script&lang=js"
import style0 from "./EditDrugs.vue?vue&type=style&index=0&id=50507a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50507a98",
  null
  
)

export default component.exports